import http from "@/http/aisea/axios";
const resource = "/hull_insurance/enterprises/claim_items";

export default {
  fetch(query) {
    return http.get(`${resource}`, { params: query });
  },

  add(payload) {
    return http.post(`${resource}`, payload);
  },

  update(id, payload) {
    return http.put(`${resource}/${id}`, payload);
  },

  delete(id) {
    return http.delete(`${resource}/${id}`);
  },
};
